import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://proveedores.justo.mx/justo.mx/api/',
  // baseURL: 'http://localhost:4007/justo.mx/api/',
});

export default axiosInstance;
